jQuery(document).ready(function () {

    const carouselItem = $('.carousel-item');
    const carousel = $('#testimonial-cards');
    const carouselDots = $('.carousel-dots-xs .dot')

    // Show the carousel dots only on xs screens (max-width: 767px)
    function toggleCarouselDots() {
        const enableDots = window.innerWidth <= 767
        $('.carousel-dots-xs').toggle(enableDots);
        !enableDots ? carouselDots.removeClass('active') : carouselDots.first().addClass('active');
        carousel.css("transform", `translateX(0%)`);
    }

    // Initial check and on window resize
    toggleCarouselDots();
    $(window).on('resize', toggleCarouselDots);

    // Handle carousel navigation when clicking on dots
    let lastActiveItemIndex = 0
    let translateX = 0


    carouselDots.on('click', function () {
        // Get the index of the clicked dot
        let currentClickedBtnIndex = $(this).index();
        translateX = 100 * currentClickedBtnIndex;
        lastActiveItemIndex = currentClickedBtnIndex

        // assign active class to the current clicked dot
        carouselItem.removeClass('active');
        carouselItem.eq(currentClickedBtnIndex).addClass('active');

        // transform the div current div and set other to 0
        carousel.css("transform", `translateX(-${translateX}%)`);

        // Update the active dot
        carouselDots.removeClass('active');
        $(this).addClass('active');
    });

});



// WEBPACK FOOTER //
// ./private/js/testimonials-carousel.js